module.exports = __webpack_public_path__ + "img/fono-smapa.b54aed24.png";